import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { translate } from 'react-admin';
import Button from '@material-ui/core/Button';

const CancelButton = ({ basePath, label, icon, className, classes = {}, translate}) => (
    <Button component={Link} to={basePath} label={label} className={classnames(classes.button, className)} color="primary">
        {icon}
        {translate(label)}
    </Button>
);

CancelButton.propTypes = {
    basePath: PropTypes.string,
    label: PropTypes.string,
    icon: PropTypes.element,
};

CancelButton.defaultProps = {
    label: 'ra.action.cancel'
};

export default translate(CancelButton);